export var CgIconDirective = [
    function () {
        return {
            link: function ($scope, $element, $attributes) {
                $element.addClass('cg-icon');
                for (var _i = 0, _a = Object.keys($attributes); _i < _a.length; _i++) {
                    var attribute = _a[_i];
                    if (attribute.indexOf('icon') > -1) {
                        $element.addClass('icon');
                    }
                    if (attribute.indexOf('cgIcon') > -1 || attribute.indexOf('icon') > -1) {
                        $element.removeAttr($attributes.$attr[attribute]);
                        $element.addClass($attributes.$attr[attribute]);
                    }
                }
            },
            template: '<div class="material-icons-outlined" ng-transclude></div>',
            transclude: true,
            restrict: 'E',
        };
    },
];
